export default {
  ADD_FILE(state, file) {
    state.files[file.id] = file.url
  },
  REVOKE_FILE(state, fileId) {
    delete state.files[fileId]
  }
}
